const { Criteria } = Shopware.Data;

/**
 * Auswertung: was wird gesucht, was findet nichts.
 * Die Liste "ohne Treffer" ist die wichtigste - jede Zeile ist entweder ein
 * fehlendes Synonym oder ein fehlender Artikel im Sortiment.
 */
export default {
    template: `
<sw-page class="riccardo-search-terms">
    <template #smart-bar-header><h2>Suche – Auswertung</h2></template>
    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.search.synonyms' }">Synonyme</sw-button>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.search.rules' }">Regeln</sw-button>
    </template>
    <template #content>
        <div style="padding: 24px;">
            <sw-card title="Suchen ohne Treffer" :is-loading="isLoading">
                <p style="color:#798490">
                    Diese Begriffe haben zuletzt nichts gefunden. Jede Zeile ist ein Kandidat für ein
                    Synonym – oder ein Hinweis, dass im Sortiment etwas fehlt.
                </p>
                <sw-data-grid v-if="zeroTerms" :data-source="zeroTerms" :columns="zeroColumns"
                              :show-selection="false" :show-actions="true" :compact-mode="true">
                    <template #column-term="{ item }"><strong>{{ item.term }}</strong></template>
                    <template #column-lastSearchedAt="{ item }">{{ datum(item.lastSearchedAt) }}</template>
                    <template #actions="{ item }">
                        <sw-context-menu-item @click="createSynonym(item)">Synonym anlegen</sw-context-menu-item>
                        <sw-context-menu-item @click="createRule(item)">Regel anlegen</sw-context-menu-item>
                    </template>
                </sw-data-grid>
                <sw-empty-state v-if="zeroTerms && zeroTerms.length === 0" title="Keine Fehlsuchen"
                                subline="Alle gesuchten Begriffe haben zuletzt Treffer geliefert." :absolute="false" />
            </sw-card>

            <sw-card title="Meistgesucht" :is-loading="isLoading" style="margin-top:24px;">
                <sw-data-grid v-if="topTerms" :data-source="topTerms" :columns="topColumns"
                              :show-selection="false" :show-actions="true" :compact-mode="true">
                    <template #column-term="{ item }"><strong>{{ item.term }}</strong></template>
                    <template #column-quote="{ item }">{{ quote(item) }}</template>
                    <template #column-lastSearchedAt="{ item }">{{ datum(item.lastSearchedAt) }}</template>
                    <template #actions="{ item }">
                        <sw-context-menu-item @click="createRule(item)">Treffer steuern</sw-context-menu-item>
                    </template>
                </sw-data-grid>
            </sw-card>
        </div>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { topTerms: null, zeroTerms: null, isLoading: false };
    },

    computed: {
        termRepository() {
            return this.repositoryFactory.create('riccardo_search_term');
        },
        topColumns() {
            return [
                { property: 'term', label: 'Begriff', primary: true },
                { property: 'searches', label: 'Suchen' },
                { property: 'lastHits', label: 'Treffer zuletzt' },
                { property: 'clicks', label: 'Klicks' },
                { property: 'quote', label: 'Klickrate' },
                { property: 'lastSearchedAt', label: 'zuletzt' },
            ];
        },
        zeroColumns() {
            return [
                { property: 'term', label: 'Begriff', primary: true },
                { property: 'searches', label: 'Suchen' },
                { property: 'lastSearchedAt', label: 'zuletzt' },
            ];
        },
    },

    created() {
        this.load();
    },

    methods: {
        load() {
            this.isLoading = true;

            const top = new Criteria(1, 25);
            top.addSorting(Criteria.sort('searches', 'DESC'));

            const zero = new Criteria(1, 25);
            zero.addFilter(Criteria.equals('lastHits', 0));
            zero.addSorting(Criteria.sort('searches', 'DESC'));

            Promise.all([
                this.termRepository.search(top, Shopware.Context.api),
                this.termRepository.search(zero, Shopware.Context.api),
            ]).then(([alle, leer]) => {
                this.topTerms = alle;
                this.zeroTerms = leer;
            }).finally(() => { this.isLoading = false; });
        },
        datum(wert) {
            if (!wert) return '–';
            return new Date(wert).toLocaleString('de-DE', {
                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
            });
        },
        quote(item) {
            if (!item.searches) return '–';
            return `${Math.round((item.clicks / item.searches) * 100)} %`;
        },
        createSynonym(item) {
            this.$router.push({ name: 'riccardo.search.synonyms', query: { term: item.term } });
        },
        createRule(item) {
            this.$router.push({ name: 'riccardo.search.rules', query: { term: item.term } });
        },
    },
};
